module.exports = __webpack_public_path__ + "static/img/clause_letter132.5e1f3ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/book/clause_letter132.png
// module id = p+za
// module chunks = 1